
import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { Department } from "../../../../domain/department";
import { User } from "../../../../domain/user";
import { SelectorDialogMixin } from "../../../system/dialogs/mixins";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously } from "../../../system/selectors";
import { IMultiUserListSelectorDialogCondition, instanceOfIMultiUserListSelectorDialogCondition } from "../IMultiUserListSelectorDialogCondition";
import { IMultiOrderableUserListSelectorDialogCondition, instanceOfIMultiOrderableUserListSelectorDialogCondition } from "../IMultiOrderableUserListSelectorDialogCondition";
import { IUserListSelectorDialogCondition, instanceOfIUserListSelectorDialogCondition } from "../IUserListSelectorDialogCondition";
import { MultiOrderableUserListSelectorWithFilterMixin } from "../../selectors/mixins";

@Component
export default class MultiOrderableUserListSelectorDialogMixin extends Mixins(SelectorDialogMixin, MultiOrderableUserListSelectorWithFilterMixin) implements IMultiSelectableAsynchronously<User>, IMultiSelectableConditionallyAsynchronously<User, IUserListSelectorDialogCondition> {

  get isOverSelectionMaxCount(): boolean {
    return this.selected && this.selected.length > this.selectionMaxCount;
  }

  get isSelectable(): boolean {
    return this.hasSelected && !this.isOverSelectionMaxCount;
  }

  async selectOptions(defaultOptions?: User[]): Promise<User[]> {
    return this.show<User[]>(defaultOptions);
  }

  async selectOptionsConditionally(condition: IUserListSelectorDialogCondition | IMultiUserListSelectorDialogCondition | IMultiOrderableUserListSelectorDialogCondition, defaultOptions?: User[]): Promise<User[]> {
    this.lastClickedUser = null;
    if (this.isDepartmentFeatureEnable) {
      this.department = (condition && condition.departmentId)
        ? await this.getDepartment(condition.departmentId)
        : null;
    }
    if (instanceOfIUserListSelectorDialogCondition(condition)) {
      this.name = condition.name ? condition.name : "職員";
      this.defaultSelectedProfessionCodes = condition.defaultSelectedProfessionCodes;
    }
    if (instanceOfIMultiUserListSelectorDialogCondition(condition)) {
      this.defaultMultiSelect = condition.isMultiSelectable;
    }
    if (instanceOfIMultiOrderableUserListSelectorDialogCondition(condition)) {
      this.isMultiSingleSwitchable = condition.isMultiSingleSwitchable;
    }
    this.shouldHideSelectLoginUserButton = !!condition && !!condition.shouldHideSelectLoginUserButton;
    this.shouldHideClearSelectionButton = !!condition && !!condition.shouldHideClearSelectionButton;
    return this.show<User[]>(defaultOptions);
  }

  // 必須職員は選択を外させない職員選択（対応責任者選択で使用）
  async selectOptionsRequiredConditionally(condition: IUserListSelectorDialogCondition | IMultiUserListSelectorDialogCondition | IMultiOrderableUserListSelectorDialogCondition, defaultOptions?: User[], requiredOptions?: User[]): Promise<User[]> {
    this.requiredUsers = requiredOptions;
    this.validate = this.validateRequired;
    return !condition ? this.selectOptions(defaultOptions) : this.selectOptionsConditionally(condition, defaultOptions);
  }

  private async getDepartment(departmentId: string): Promise<Department> {
    try {
      return await DomainRegistry.department.getDepartmentRepository().getEntity(departmentId);
    } catch (e) {
      console.warn(e);
      return null;
    } 
  }

  onUserSelectorDblClicked(e: PointerEvent): void {
    this.select([this.lastClickedUser]);
  }

  selectLoginUser(): void {
    this.select([this.$store.getters.user]);
  }
}
